import { useEffect } from "react";

const SITE_URL = "https://transrentus.lt";

function upsertMeta(selector: string, key: string, value: string, attr: "name" | "property") {
  let el = document.head.querySelector<HTMLMetaElement>(selector);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function upsertCanonical(href: string) {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function upsertTag(fullHref: string) {
  let el = document.head.querySelector<HTMLLinkElement>('link[rel="alternate"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "alternate");
    el.setAttribute("hreflang", "lt");
    document.head.appendChild(el);
  }
  el.setAttribute("href", fullHref);
}

/**
 * Sets per-page SEO tags for a client-rendered SPA: title, meta description,
 * canonical URL, Open Graph tags and the document language.
 */
export function useSeo({
  title,
  description,
  path = "/",
  lang = "lt",
}: {
  title: string;
  description?: string;
  path?: string;
  lang?: string;
}) {
  useEffect(() => {
    const url = `${SITE_URL}${path === "/" ? "" : path}`;
    document.title = title;
    document.documentElement.lang = lang;

    upsertMeta('meta[name="description"]', "description", description ?? "", "name");
    upsertMeta('meta[property="og:title"]', "og:title", title, "property");
    upsertMeta('meta[property="og:url"]', "og:url", url, "property");
    upsertMeta('meta[property="og:description"]', "og:description", description ?? "", "property");
    upsertMeta('meta[property="og:locale"]', "og:locale", lang === "lt" ? "lt_LT" : "en_US", "property");
    upsertMeta('meta[name="twitter:title"]', "twitter:title", title, "name");
    upsertMeta('meta[name="twitter:description"]', "twitter:description", description ?? "", "name");
    upsertCanonical(url);
    upsertTag(url);
  }, [title, description, path, lang]);
}
